import { Controller } from "stimulus"
import debounce from "lodash/debounce"

export default class extends Controller {
  static targets = ["status", "available", "range", "time"]

  connect() {
    this.submitting = false
    this.pendingSubmit = false
    this.boundSubmitEnd = this.submitEnd.bind(this)
    this.debouncedSubmit = debounce(this.submit.bind(this), 500)
    this.element.addEventListener("turbo:submit-end", this.boundSubmitEnd)
    this.syncTimeFields()
  }

  disconnect() {
    this.debouncedSubmit.cancel()
    this.element.removeEventListener("turbo:submit-end", this.boundSubmitEnd)
  }

  changed(event) {
    if (event.target.matches("input[type='checkbox'][name*='available']")) {
      if (this.hasStatusTarget) {
        this.statusTarget.textContent = event.target.checked ? "Open" : "Closed"
      }

      this.syncTimeFields()
      this.debouncedSubmit.cancel()
      this.submit()
      return
    }

    this.debouncedSubmit()
  }

  syncTimeFields() {
    if (!this.hasAvailableTarget) return

    const open = this.availableTarget.checked

    if (this.hasRangeTarget) {
      this.rangeTarget.classList.toggle("d-none", !open)
    }

    // Keep hidden fields out of constraint validation / submit while closed.
    this.timeTargets.forEach((input) => {
      input.disabled = !open
    })
  }

  submit() {
    if (this.submitting) {
      this.pendingSubmit = true
      return
    }

    // Incomplete time values (common while typing) make the form invalid.
    // requestSubmit() then aborts without a Turbo request, so turbo:submit-end
    // never fires and `submitting` would stay true forever.
    if (!this.element.checkValidity()) {
      this.pendingSubmit = false
      return
    }

    this.submitting = true
    this.pendingSubmit = false
    this.element.requestSubmit()
  }

  submitEnd() {
    this.submitting = false

    if (this.pendingSubmit) {
      this.submit()
    }
  }
}
